import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { AiClient, aiApiRef } from './api/AiApi';

export const aiPlugin = createPlugin({
  id: 'ai',
  routes: { root: rootRouteRef },
  apis: [
    createApiFactory({
      api: aiApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new AiClient({ discoveryApi, fetchApi }),
    }),
  ],
});

/** The assistant, mounted at /ai. */
export const AiChatPage = aiPlugin.provide(
  createRoutableExtension({
    name: 'AiChatPage',
    component: () => import('./components/AiChatPage').then(m => m.AiChatPage),
    mountPoint: rootRouteRef,
  }),
);
